const copiesIframe = document.querySelectorAll('.copy-iframe');
copiesIframe?.forEach(button => {
    button.addEventListener('click', async function () {
        // console.log('Copie iframe demandée');

        const iframeCode = this.getAttribute('data-iframe');
        try {
            await navigator.clipboard.writeText(iframeCode);
            alert('Iframe copiée dans le presse-papier !');
        } catch (err) {
            console.error('Erreur lors de la copie :', err);
            alert('La copie a échoué.');
        }
    });
});